// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"abTJX":[function(require,module,exports,__globalThis) {
var _imageTextGrid = require("./sections/image-text-grid");
// Add your modules to this array
const modules = [
    // exampleSection,
    // variantLabelFormatter,
    (0, _imageTextGrid.imageTextGrid)
];
initModules(modules);
function initModules(modules) {
    modules.forEach((module)=>{
        module.init();
    });
}

},{"./sections/image-text-grid":"3FsDp"}],"3FsDp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "imageTextGrid", ()=>imageTextGrid);
var _moduleClass = require("../globals/module-class");
class ImageTextGridModule extends (0, _moduleClass.FLModule) {
    constructor(){
        super("ImageTextGrid");
    }
    init() {
        if (window.customElements.get("image-text-grid")) return;
        class ImageTextGrid extends HTMLElement {
            connectedCallback() {
                if (this.hasAttribute("data-initialized")) return;
                this.setAttribute("data-initialized", "true");
                this.setupReveal();
            }
            setupReveal() {
                const items = Array.from(this.querySelectorAll('[reveal-on-scroll="true"]'));
                if (items.length === 0) return;
                const motionSafe = window.matchMedia("(prefers-reduced-motion: no-preference)").matches;
                const supportsObserver = "IntersectionObserver" in window;
                if (!motionSafe || !supportsObserver) {
                    items.forEach((item)=>this.revealImmediately(item));
                    return;
                }
                items.forEach((item, index)=>{
                    item.setAttribute("data-reveal-index", index.toString());
                });
                const observer = new IntersectionObserver((entries)=>{
                    entries.forEach((entry)=>{
                        if (!entry.isIntersecting) return;
                        observer.unobserve(entry.target);
                        this.revealWithAnimation(entry.target);
                    });
                }, {
                    rootMargin: "-200px 0px 0px 0px"
                });
                items.forEach((item)=>observer.observe(item));
            }
            revealImmediately(target) {
                const element = target;
                element.removeAttribute("reveal-on-scroll");
                element.style.opacity = "1";
                element.style.transform = "none";
            }
            async revealWithAnimation(target) {
                const element = target;
                await this.waitForImage(element);
                element.removeAttribute("reveal-on-scroll");
                element.style.opacity = "0";
                element.style.transform = "translateY(10%)";
                if (typeof element.animate === "function") {
                    const index = Number(element.getAttribute("data-reveal-index") || "0");
                    const delay = index * 60;
                    element.animate([
                        {
                            opacity: 0,
                            transform: "translateY(10%)"
                        },
                        {
                            opacity: 1,
                            transform: "translateY(0)"
                        }
                    ], {
                        duration: 350,
                        easing: "ease",
                        fill: "forwards",
                        delay
                    });
                } else {
                    element.style.opacity = "1";
                    element.style.transform = "none";
                }
            }
            waitForImage(target) {
                const image = target.querySelector(":scope > img, :scope > picture img");
                if (!image || image.complete) return Promise.resolve();
                return new Promise((resolve)=>{
                    image.addEventListener("load", resolve, {
                        once: true
                    });
                    image.addEventListener("error", resolve, {
                        once: true
                    });
                });
            }
        }
        window.customElements.define("image-text-grid", ImageTextGrid);
    }
}
const imageTextGrid = new ImageTextGridModule();

},{"../globals/module-class":"h53Ln","@parcel/transformer-js/src/esmodule-helpers.js":"4Lnzq"}],"h53Ln":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FLModule", ()=>FLModule);
var _logger = require("./logger");
class FLModule {
    constructor(moduleName){
        this.moduleName = moduleName;
        const logger = (0, _logger.createLogger)(moduleName);
        this.log = logger.log;
        this.trace = logger.trace;
    }
}

},{"./logger":"bU6uf","@parcel/transformer-js/src/esmodule-helpers.js":"4Lnzq"}],"bU6uf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createLogger", ()=>createLogger);
const createLogger = (moduleName, debugModeCheck = ()=>window.location.href.includes("127.0.0.1"))=>{
    const formatModulePrefix = ()=>moduleName ? `[${moduleName}]` : "";
    const isDebugMode = ()=>debugModeCheck();
    return {
        log: (...args)=>{
            if (isDebugMode()) console.log(formatModulePrefix(), ...args);
        },
        trace: (...args)=>{
            if (isDebugMode()) console.trace(formatModulePrefix(), ...args);
        }
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"4Lnzq"}],"4Lnzq":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}]},["abTJX"], "abTJX", "parcelRequired118", {})

